import { put, call } from "redux-saga/effects";
import { EventDetailsAPI } from "../../utils/api/EventDetailsAPI";
import {GET_EVENTFLOW_SUCCESS,GET_EVENTFLOW_FAILED, SAVE_EVENTFLOW_SUCCESS,SAVE_EVENTFLOW_FAILED ,
        UPDATE_EVENTFLOW_SUCCESS,UPDATE_EVENTFLOW_FAILED} from "../actions/EventDetails";

export function* geteventFlowInitiation (request:any) {
    try {
      
        const result = yield call(EventDetailsAPI.geteventFlowInitiation,request.input);
    
       // var status = result.data;
     
      yield put({
          type: GET_EVENTFLOW_SUCCESS,
          payload: result.data,
          input: request.input
        });
    } catch (e) {
        yield put({ type: GET_EVENTFLOW_FAILED, payload: e.message });
    }
  }

  export function* eventFlowInitiationCreate(request: any) {
 
    try {
           const result=yield call(EventDetailsAPI.eventFlowInitiationCreate, request.input);
         yield put({ 
            type: SAVE_EVENTFLOW_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_EVENTFLOW_FAILED, payload: e.message });
    }
}

export function* eventFlowInitiationUpdate(request: any) {
  
    try {
           const result=yield call(EventDetailsAPI.eventFlowInitiationUpdate, request.input);
         yield put({ 
            type: UPDATE_EVENTFLOW_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_EVENTFLOW_FAILED, payload: e.message });
    }
}
